// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { formatDate } from '@angular/common';
import { SettingsService } from 'src/app/modules/shared/services/settings.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LocalDateFormat } from 'src/app/_interfaces/data/local-data-format-model';

export const PICK_FORMATS = {
  parse: { dateInput: 'YYYY-MM-DD' },
  display: {
    dateInput: 'input',
    monthYearLabel: 'monthYear',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  currentFormat = '';
  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private settingsService: SettingsService,
  ) {
    super(locale);
    this.settingsService.dateFormat$
      .pipe(takeUntilDestroyed())
      .subscribe((dateformat: LocalDateFormat) => {
        this.currentFormat = dateformat.longFormat;
      });
  }

  override format(date: Date, displayFormat: string): string {
    if (displayFormat === PICK_FORMATS.display.monthYearLabel) {
      return formatDate(date, 'MMM yyyy', this.locale);
    }
    if (displayFormat === PICK_FORMATS.display.dateInput) {
      return formatDate(date, this.currentFormat, this.locale);
    }
    return date.toDateString();
  }
}
